import { grey } from './colors';
export const border = (mode)=>{
    return mode === 'light' ? {
        prominent: grey[300],
        subtle: grey[150]
    } : {
        prominent: grey[600],
        subtle: grey[850]
    };
};

//# sourceMappingURL=border.js.map